/*
 * IMPORTS
 */
import React from 'react' // NPM: React.js library.
import _ from 'underscore' // NPM: Underscore.js library for  functional suspects (each, map, reduce, filter...) .
import { client, urlFor } from '../../client' // Helper from sanity.io for data.
import { motion } from 'framer-motion' // NPM: framer-motion for motion and animation.

/*
 * STYLES
 */
import './index.scss'

/*
 * CONSTANTS
 */

import { AppWrap, MotionWrap } from '../../wrapper'

/*
 * OBJECTS
 */

const Index = () => {
  // Hook Assignment
  const [conclusionData, setConclusionData] = React.useState([])
  // UseEffect
  React.useEffect(() => {
    const query = '*[_type == "conclusion"]'
    client.fetch(query).then(data => setConclusionData(data))
  }, [])

  return (
    <>
      <div className='app__main-conclusion'>
        <div className='heading'>
                Conclusion
        </div>
        <div className='content'>
          { conclusionData && conclusionData[0]?.conclusion_content}

        </div>
      </div>
    </>
  )
}

/*
 * EXPORTS
 */
export default AppWrap(
  MotionWrap(Index, 'app__about'),
  'home'
)
